import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ProcessProgress } from './ProcessProgress';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  private subject: Subject<ProcessProgress> = new Subject();

  constructor() {
  }

  getSubject(): Observable<ProcessProgress> {
    return this.subject.asObservable();
  }

  startProgress(
      processProgress: ProcessProgress
  ): void {
    processProgress.action = 'start';
    this.subject.next(processProgress);
  }

  stopProgress(): void {
    const process: ProcessProgress = {
      action: 'stop'
    };
    this.subject.next(process);
  }

  updateProgress(processProgress: ProcessProgress): void {
    processProgress.action = 'update';
    this.subject.next(processProgress);
  }

}
